export enum LiftErrors {
  DELETE = 'lifts/deleteLift',
  CREATE = 'lifts/createLift',
  EDIT = 'lifts/editLift',
  GET = 'lifts/getLift'
}
